import _uniq from 'lodash/uniq';
export const keywordsToArray = keywords => {
  if (!keywords) {
    return [];
  }
  const keywordsArray = keywords.split(',').map(word => word.trim());

  return _uniq(
    keywordsArray
      .map(keyword => {
        // Since we split the string above on every comma, sometimes there can
        // be keywords that are enclosed in double quotations but also contain commas.
        // E.g. 'Apple, pear, "cheddar, cheese"'.
        // We then need to check if the keyword contains an uneven amount of quotes
        // and strip it.
        if (keyword.indexOf('"') !== -1 && !/^"[^"]+"$/.test(keyword)) {
          return keyword.replace('"', '');
        }

        return keyword;
      })
      .filter(Boolean)
  );
};
const isValidKeyword = word => /^"[^"]+"$|^[^"]+$/.test(word);
export const isValidKeywords = keywords => {
  // Allow each word to optionally be enclosed in double quotations,
  // but allow no double quotes beyond that.
  // See tests for examples.

  if (keywords) {
    const words = keywordsToArray(keywords);
    return words.every(isValidKeyword);
  }
  return true;
};
